<template>
  <div class="relative">
    <BaseDatePicker
      v-model="date"
      class="bg-surface-container-high"
      required
      hide-decorators
      :min-date="minDate"
      v-slot="{ value }"
    >
      <BaseSettingItem
        class="bg-surface-container"
        :title="label"
        :description="date ? value : $t('survey.nextOccurrenceAtEmpty')"
        icon="today"
      />
    </BaseDatePicker>
    <BaseIconButton
      v-if="date"
      icon="clear"
      color="outlined"
      class="absolute! top-1/2 right-4 -translate-y-1/2"
      @click="clearDate"
    />
  </div>
</template>
<script setup lang="ts">
  import BaseDatePicker from '@/core/components/base/date-picker/BaseDatePicker.vue'
  import BaseSettingItem from '@/core/components/base/setting-item/BaseSettingItem.vue'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'

  interface Props {
    label: string
    minDate?: Date
  }

  defineProps<Props>()

  const date = defineModel<Date | undefined>({
    required: true,
  })

  const clearDate = () => {
    date.value = undefined
  }
</script>
